import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable no-restricted-imports */
import KustomLogoSVG from '../../../static/kustom.svg';
/* eslint-disable no-restricted-imports */

const KustomLogo = ({ height = '22px' }) => {
  return (
    <img src={KustomLogoSVG} alt="Kustom Logo" style={{ height, width: 'auto', marginRight: 2 }} />
  );
};

KustomLogo.propTypes = {
  height: PropTypes.string,
};

export { KustomLogo };
